module.exports = __webpack_public_path__ + "static/img/fm2.799c3eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fm2.jpg
// module id = nQgc
// module chunks = 1